import { liteClient } from 'algoliasearch/lite';

import { applicationId, readToken } from './client.env';

const searchClient = liteClient(applicationId, readToken);

export default searchClient;
